// Focus trap utility — cycles Tab focus within a container (WCAG 2.4.3).
const FOCUSABLE =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

export function createFocusTrap(container) {
  let previousFocus = null;

  const getFocusable = () =>
    Array.from(container.querySelectorAll(FOCUSABLE)).filter(
      (el) => el.offsetParent !== null
    );

  const onKeyDown = (event) => {
    if (event.key !== "Tab") return;
    const focusable = getFocusable();
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey) {
      if (document.activeElement === first) {
        event.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  };

  return {
    activate() {
      previousFocus = document.activeElement;
      container.addEventListener("keydown", onKeyDown);
      // Focus first focusable element after a short delay
      requestAnimationFrame(() => {
        const focusable = getFocusable();
        if (focusable.length) focusable[0].focus();
      });
    },
    deactivate() {
      container.removeEventListener("keydown", onKeyDown);
      if (previousFocus && previousFocus.focus) {
        previousFocus.focus();
      }
      previousFocus = null;
    },
  };
}
